import React from 'react';
import { CreateReport } from '../../../components';
import { paths } from '../../../routes';
import { useAnomalies } from '../../../hooks/theme.hook';
import * as Yup from 'yup';

export const VersementForms: React.FC = () => {
  const { selectedAnomalyType, anomalyTypes, anomalies, handleOnSelectAnomalyType } = useAnomalies(
    '' + paths.versement.themeShortCode
  );

  return (
    <CreateReport
      initialValues={{
        fieldReportsDto: {},
      }}
      themeShortCode={paths.versement.themeShortCode || ''}
      otherFields={{
        'fieldReportsDto.suge': {
          type: 'switch',
          label: 'Présence de la SUGE / Agent de sûreté',
          grid: 12,
        },

        anomalyTypeShortCode: {
          type: 'select',
          label: "Type d'anomalie",
          grid: 6,
          options: anomalyTypes,
        },
        anomalyShortCode: {
          type: 'select',
          label: 'Anomalie',
          grid: 6,
          options: anomalies,
          disabled: !selectedAnomalyType,
        },
        'fieldReportsDto.nbrPV': {
          type: 'number',
          label: 'Nombre de PV',
          grid: 6,
        },
        'fieldReportsDto.versementNumber': {
          type: 'number',
          label: 'Numero de versement',
          grid: 6,
        },
        'fieldReportsDto.comment': {
          type: 'text',
          name: 'fact',
          label: 'Exposer les faits',
          multiline: true,
          rows: 4,
          rowsMax: 15,
        },
      }}
      onChange={handleOnSelectAnomalyType}
      validationSchema={Yup.object({
        serviceName: Yup.string().required('Ce champ est requis').nullable(),
        anomalyTypeShortCode: Yup.string().required('Ce champ est requis'),
        anomalyShortCode: Yup.string().required('Ce champ est requis'),
      })}
    />
  );
};

export default VersementForms;
